import React, { useContext } from 'react';
import { useCartPricing } from '../../contexts/CartPricingContext';
import CheckoutContext from '../../lib/CheckoutContext';
import CartItemList from '../CartItemList';
import AccountCreditAppliedLineItem from './AccountCreditAppliedLineItem';
import CouponLineItem from './CouponLineItem';
import GiftCardAppliedLineItem from './GiftCardAppliedLineItem';
import styles from './ItemsInCart.module.scss';
import ReferralCodeLineItem from './ReferralCodeLineItem';
import { getFiGrowthBook } from '../../lib/growthbook';

export interface ItemsInCartProps {
  allowRemoveCartItem?: boolean;
  allowRemoveCode?: boolean;
  /** controls the default expanded state of WhatsIncluded in CartItemV2 (default: true) */
  defaultExpanded?: boolean;
}

export default function ItemsInCart({ allowRemoveCartItem, allowRemoveCode, defaultExpanded }: ItemsInCartProps) {
  const { cart } = useContext(CheckoutContext);
  const cartPricing = useCartPricing();
  const showEcomCartTest = getFiGrowthBook().getFeatureValue('ecom-cart-test', false);

  return (
    <div className={styles.main}>
      <CartItemList allowRemoveCartItem={allowRemoveCartItem} defaultExpanded={defaultExpanded} />
      {!!cart.couponCode && !showEcomCartTest && !cart.referralCode && (
        <CouponLineItem
          allowRemoveCoupon={allowRemoveCode}
          appliedDiscountInMonths={
            cartPricing.couponDiscount?.type === 'months' ? cartPricing.couponDiscount?.months : 0
          }
          appliedDiscountInCents={
            cartPricing.couponDiscount?.type === 'dollars' ? cartPricing.couponDiscount?.discountAmountInCents : 0
          }
          couponCode={cart.couponCode}
          validationError={cartPricing.validationErrors?.couponCode?.message}
        />
      )}
      {!!cart.referralCode && !showEcomCartTest && (
        <ReferralCodeLineItem
          referreeFreeMonth={cartPricing.referreeEligibleForFreeMonth}
          refereeCartDiscount={cartPricing.referreeEligibleForCartDiscount}
          allowRemoveReferralCode={allowRemoveCode}
          appliedDiscountInCents={cartPricing.appliedDiscountInCents}
          validationError={cartPricing.validationErrors?.referralCode?.message}
        />
      )}
      {!!cartPricing.appliedAccountBalanceInCents && !showEcomCartTest && (
        <AccountCreditAppliedLineItem appliedAccountBalanceInCents={cartPricing.appliedAccountBalanceInCents} />
      )}
      {!!cart.redeemedGiftCardCode && !showEcomCartTest && (
        <GiftCardAppliedLineItem
          allowRemoveGiftCard={allowRemoveCode}
          redeemedGiftCardCode={cart.redeemedGiftCardCode}
          appliedGiftCardAmountInCents={cartPricing.appliedGiftCardAmountInCents}
          totalValueOfRedeemedGiftCardInCents={cartPricing.totalValueOfRedeemedGiftCardInCents}
          validationError={cartPricing.validationErrors?.redeemedGiftCardCode?.message}
        />
      )}
    </div>
  );
}
